import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => (
    {
      top: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
      },
      rotate: {
        transition: 'transform 0.3s',
      },
      actions: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '16px',
      },
      actionsButtons: {
        marginLeft: '3px',
        marginRight: '3px',
      },
      actionsDivider: {
        marginLeft: '4px',
        marginRight: '8px',
      },
    }
  )
);

export default useStyles;
